// campaigns/index.js — routes for campaign library + editor + analytics detail
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CampaignsList from './campaignsList.js';
import CampaignEditor from './campaignEditor.js';
import CampaignDetail from './campaignDetail.js';

const Campaigns = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={CampaignsList} />
    <Route exact path={`${match.url}/new`} component={CampaignEditor} />
    <Route exact path={`${match.url}/:id/edit`} component={CampaignEditor} />
    <Route exact path={`${match.url}/:id/analytics`} component={CampaignDetail} />
    <Redirect to={`${match.url}`} />
  </Switch>
);

export default Campaigns;
